// contact us
import './index.less'
import { verifyEmail } from '@utils/index.js'
import { shopCR, resellerSubmit } from '@utils/api.js'

class becomeReseller {
  constructor(el) {
    this.DOM = { el };

    this.init()
  }
  init() {
    this.submit()
    this.focus()
  }
  submit() {
    let _self = this;
    $('.J-reseller-submit').click(function() {
      if (_self.checkForm()) {
        let params = {
          cr: shopCR,
          companyName: $('#Reseller_Company_Name').val(),
          officeAddress: $('#Reseller_Office_Address').val(),
          contactName: $('#Reseller_Contact_Name').val(),
          title: $('#Become_Reseller_Title').val(),
          email: $('#Become_Reseller_Email').val(),
          companyPhone: $('#Reseller_Company_Phone').val(),
          yearsInBusiness: $('#Become_Reseller_Years').val(),
          numberOfEmployees: $('#Become_Reseller_Employees').val(),
          website: $('#Become_Reseller_Website').val(),
          mainMarket: $('#Become_Reseller_markets').val(),
          typeOfBusiness: $('#Reseller_Business_Type').val(),
          numberOfPhysical: $('#Reseller_Physical_Retail').val(),
          sellOnYouSite: $('#Become_Reseller_Site').val(),
          majorBrands: $('#Reseller_Major_Brands').val(),
          mainSellChannels: $('#Reseller_Main_Channels').val(),
          willSellINStores: $('#Become_Reseller_Stores').val(),
          sellDirectToEnd: $('#Reseller_Sell_Direct').val(),
          sellToBusiness: $('#Reseller_Sell_To').val(),
          generalCustomer: $('#Reseller_Customer_Demographic').val(),
          amountOfAnnual: $('#Reseller_Annual_Turnover').val(),
          expectedMargin: $('#Reseller_Expected_Margin').val(),
          paymentTerms: $('#Reseller_Payment_Terms').val(),
          orderInventory: $('#Become_Order_Inventory').val(),
          workThrough: $('#Reseller_Through_Distributor').val(),
          revenuesOverPast: $('#Reseller_Revenues_Months').val(),
          ableToShipBatteries: $('#Become_Batteries_Larger').val(),
          notAllow: $('#Reseller_Follow_Rule').val(),
          whereLearnAbout: $('#Reseller_Learn_Jackery').val(),
          whatKindsOfMarketing: $('#Reseller_Kinds_Marketing').val(),
          anyCommentsToUs: $('#Reseller_Any_Comments').val()
        }
        $('.J-reseller-submit').addClass('btn--loading')
        resellerSubmit(params).then(res => {
          pushSuccessMessage( shopCR === 'DE'
          ? 'Ihre Bewerbung wurde erfolgreich übermittelt! Wir werden uns in Kürze bei Ihnen melden.'
          : "Your application has been successfully submitted! We will be in touch with you shortly.")
          _self.resetFormData()
          $('.J-reseller-submit').removeClass('btn--loading')
        })
        .catch(err => {
          if (err.status != 500) {
            pushErrorMessage(shopCR === 'DE'
            ? 'Hoppla! Etwas ist schiefgelaufen! Probieren Sie es auf eine andere Weise!'
            : "Woops! Something wrong! Try another way!")
          }
          $('.J-reseller-submit').removeClass('btn--loading')
        })
      } else {
        let top = $('.J-reseller-form .red').first().offset().top
        if (top) {
          $('html, body').animate({ scrollTop: top - 150 }, 'slow');
        }
      }
    })
  }
  checkForm() {
    let checkStatus = true
    const regex = /^[\d+\-() ]{0,20}$/;
    const regexNum=/(^[1-9]\d{0,5}(\.[0-9]{0})?$)|(^[0](\.\d{0})?$)|(^[1][0]{6}(\.[0]{0})?$)/
    if (!$('#Reseller_Company_Name').val()) {
      $('#Reseller_Company_Name').addClass('red')
      checkStatus = false
    }
    if (!$('#Reseller_Office_Address').val()) {
      $('#Reseller_Office_Address').addClass('red')
      checkStatus = false
    }
    if (!$('#Reseller_Contact_Name').val()) {
      $('#Reseller_Contact_Name').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_Title').val()) {
      $('#Become_Reseller_Title').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_Email').val() || !verifyEmail($('#Become_Reseller_Email').val())) {
      $('#Become_Reseller_Email').addClass('red')
      checkStatus = false
    }
    if (!$('#Reseller_Company_Phone').val() || !regex.test($('#Reseller_Company_Phone').val())) {
      $('#Reseller_Company_Phone').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_Years').val()) {
      $('#Become_Reseller_Years').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_Employees').val() || !regexNum.test($('#Become_Reseller_Employees').val())) {
      $('#Become_Reseller_Employees').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_Website').val()) {
      $('#Become_Reseller_Website').addClass('red')
      checkStatus = false
    }
    if (!$('#Become_Reseller_markets').val()) {
      $('#Become_Reseller_markets').addClass('red')
      checkStatus = false
    }
    return checkStatus
  }
  focus() {
    $('.J-reseller-form input').focus(function() {
      $(this).removeClass('red')
    })
  }
  resetFormData() {
    $('#Reseller_Company_Name').val('')
    $('#Reseller_Office_Address').val('')
    $('#Reseller_Contact_Name').val('')
    $('#Become_Reseller_Title').val('')
    $('#Become_Reseller_Email').val('')
    $('#Reseller_Company_Phone').val('')
    $('#Become_Reseller_Years').val('')
    $('#Become_Reseller_Employees').val('')
    $('#Become_Reseller_Website').val('')
    $('#Become_Reseller_markets').val('')
    $('#Reseller_Business_Type').val('')
    $('#Reseller_Physical_Retail').val('')
    $('#Become_Reseller_Site').val('')
    $('#Reseller_Major_Brands').val('')
    $('#Reseller_Main_Channels').val('')
    $('#Become_Reseller_Stores').val('')
    $('#Reseller_Sell_Direct').val('')
    $('#Reseller_Sell_To').val('')
    $('#Reseller_Customer_Demographic').val('')
    $('#Reseller_Annual_Turnover').val('')
    $('#Reseller_Expected_Margin').val('')
    $('#Reseller_Payment_Terms').val('')
    $('#Become_Order_Inventory').val('')
    $('#Reseller_Through_Distributor').val('')
    $('#Reseller_Revenues_Months').val('')
    $('#Become_Batteries_Larger').val('')
    $('#Reseller_Follow_Rule').val('')
    $('#Reseller_Learn_Jackery').val('')
    $('#Reseller_Kinds_Marketing').val('')
    $('#Reseller_Any_Comments').val('')
  }
}


$(document).ready(function() {
  new becomeReseller()
})